import React from 'react';
import sis1 from '../images/factory_purpose/888888.jpg'
import sis2 from '../images/factory_purpose/aftab-1.jpg'
import sis3 from '../images/factory_purpose/333333-1.jpg'

const SisterConcern = () => {
  return (
    <></>
  );
};

export default SisterConcern;
